import styled, { keyframes } from "styled-components";

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const ReceiptContainer = styled.div`
  padding: 24px 28px 40px;
  max-width: 640px;
`;

export const ReceiptHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 26px;
  animation: ${fadeUp} 0.45s ease both;

  .eyebrow {
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent);
  }

  h1 {
    margin: 0;
    font-family: var(--font-display);
    font-size: 2rem;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: var(--text);
    line-height: 1.1;
  }

  p {
    margin: 0;
    color: var(--text-muted);
    font-size: 0.95rem;
  }
`;

export const ReceiptCard = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 22px;
  border-radius: 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  cursor: pointer;
  animation: ${fadeUp} 0.45s ease both;
  animation-delay: 80ms;
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-lg);
    border-color: var(--accent);
  }
`;

export const ReceiptCardIcon = styled.div`
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  color: #fff;
  background: var(--gradient-brand);
  box-shadow: var(--glow);

  svg {
    font-size: 26px;
  }
`;

export const ReceiptCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  h2 {
    margin: 0;
    font-family: var(--font-display);
    font-size: 1.15rem;
    font-weight: 700;
    color: var(--text);
  }

  p {
    margin: 0;
    font-size: 0.88rem;
    color: var(--text-muted);
  }
`;
